<template>
  <el-dialog title="消息" :visible.sync="show" width="500px" center :before-close="handleClose">
    <div v-if="noticeData.length" style="white-space: pre-wrap">{{ noticeData[index].noticeDetails }}</div>

    <div slot="footer" class="dialog-footer" style="text-align: center">
      <el-button v-if="noticeData.length > 1 && index > 0" @click="index--">上一条</el-button>
      <el-button v-if="noticeData.length > 1 && index < noticeData.length - 1" @click="index++">下一条</el-button>

      <el-button type="primary" :loading="loading" @click="readNotice">已阅读</el-button>
      <el-button v-if="noticeData.length > 1" type="primary" @click="readAll">全部阅读</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isCkeckNoticet, readNotice } from "@/api/navbar";

export default {
  data() {
    return {
      show: false,
      noticeData: [],
      index: 0,
      loading: false
    };
  },
  watch: {
    "$store.state.user.showNotice"(val) {
      if (val) {
        this.publicAdministrations();
      } else {
        this.show = this.$store.state.user.showNotice;
      }
    }
  },
  methods: {
    readAll() {
      this.noticeData.map(item => {
        readNotice({ id: item.id });
      });
      this.handleClose();
    },
    readNotice() {
      this.loading = true;
      readNotice({ id: this.noticeData[this.index].id })
        .then(() => {
          if (this.noticeData.length > 1) {
            this.index === this.noticeData.length - 1 ? this.index-- : this.index;
            this.noticeData.splice(this.index + 1, 1);
          } else {
            this.handleClose();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
      this.$store.state.user.showNotice = false;
    },
    // 获取公告列表
    publicAdministrations() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(225, 225, 225, 0.7)"
      });
      isCkeckNoticet()
        .then(res => {
          if (res.data.toastList) {
            this.noticeData = res.data.toastList;
            this.index = 0;
            this.show = true;
          } else {
            this.$store.state.user.showNotice = false;
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    }
  }
};
</script>
